/* eslint-disable no-unused-vars */
/* eslint-disable lines-around-comment */

import { getCurrentConference } from '../base/conference/functions';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import {
  participantJoined,
  participantLeft
} from '../base/participants/actions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';

import {
  RESET_WHITEBOARD,
  SET_WHITEBOARD_OPEN,
  TOGGLE_WHITEBOARD
} from './actionTypes';
import { resetWhiteboard, setWhiteboardOpen, setupWhiteboard } from './actions';
import { WHITEBOARD_ID, WHITEBOARD_PARTICIPANT_NAME } from './constants';
import {
  getCollabDetails,
  getCollabServerUrl,
  isWhiteboardPresent
} from './functions';
import { FakeParticipant } from '../base/participants/types';
import { generateCollaborationLinkData } from '@jitsi/excalidraw';
import { getCurrentRoomId } from '../breakout-rooms/functions';
import { WhiteboardStatus } from './types';
import { sendAnalytics } from '../analytics';
import { getLocalParticipant } from '../base/participants';
import { sendMessage } from '../chat';

const focusWhiteboard = (store) => {
  const { dispatch, getState } = store;
  const state = getState();
  const conference = getCurrentConference(state);
  //   const stageFilmstrip = isStageFilmstripAvailable(state);
  const isPresent = isWhiteboardPresent(state);
  if (conference) {
    if (!isPresent) {
      dispatch(
        participantJoined({
          conference,
          fakeParticipant: FakeParticipant.Whiteboard,
          id: WHITEBOARD_ID,
          name: WHITEBOARD_PARTICIPANT_NAME
        })
      );
    }
    dispatch({ type: TOGGLE_WHITEBOARD, isOpen: true });
    // dispatch(setupWhiteboard({ collabDetails, isOpen: true }));
  }
  // if (stageFilmstrip) {
  //     dispatch(addStageParticipant(WHITEBOARD_ID, true));
  // } else {
  // dispatch(pinParticipant(WHITEBOARD_ID));
  // }
};

/**
 * Middleware which intercepts whiteboard actions to handle changes to the related state.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => (next) => async (action) => {
  const { dispatch, getState } = store;
  const state = getState();
  const conference = getCurrentConference(state);

  switch (action.type) {
    case SET_WHITEBOARD_OPEN: {
      const existingCollabDetails = getCollabDetails(state);

      if (!existingCollabDetails && action.isOpen) {
        const collabDetails = await generateCollaborationLinkData();
        const collabServerUrl = getCollabServerUrl(state);
        // const roomId = getCurrentRoomId(state);
        // const collabDetails = {
        //   roomId,
        //   roomKey: collabLinkData.roomKey
        // };

        focusWhiteboard(store);
        dispatch(setupWhiteboard({ collabDetails }));
        conference.getMetadataHandler().setMetadata(WHITEBOARD_ID, {
          collabServerUrl,
          collabDetails
        });
        raiseWhiteboardNotification(WhiteboardStatus.INSTANTIATED);
        const message = {
          EventType: 21,
          Message: 'Whiteboard',
          FromParticipantID: getLocalParticipant(state).id,
          collabDetails
        };
        dispatch(sendMessage(JSON.stringify(message)));
        return;
      }

      if (action.isOpen) {
        focusWhiteboard(store);
        sendAnalytics({ action: 'whiteboard.open' });
        raiseWhiteboardNotification(WhiteboardStatus.SHOWN);
        return;
      }
      dispatch({ type: TOGGLE_WHITEBOARD, isOpen: false });
      dispatch(
        participantLeft(WHITEBOARD_ID, conference, {
          fakeParticipant: FakeParticipant.Whiteboard
        })
      );
      raiseWhiteboardNotification(WhiteboardStatus.HIDDEN);
      break;
    }
    case RESET_WHITEBOARD: {
      dispatch({ type: TOGGLE_WHITEBOARD, isOpen: false });
      dispatch(
        participantLeft(WHITEBOARD_ID, conference, {
          fakeParticipant: FakeParticipant.Whiteboard
        })
      );
      raiseWhiteboardNotification(WhiteboardStatus.RESET);
      break;
    }
  }

  return next(action);
});

/**
 * Raises the whiteboard status notifications changes (if API is enabled).
 *
 * @param {WhiteboardStatus} status - The whiteboard changed status.
 * @returns {Function}
 */
function raiseWhiteboardNotification(status) {
  if (typeof APP !== 'undefined') {
    // eslint-disable-next-line no-undef
    APP.API.notifyWhiteboardStatusChanged(status);
  }
}

/**
 * Set up state change listener to perform maintenance tasks when the conference
 * is left or failed, e.g. Disable the whiteboard if it's left open.
 */
StateListenerRegistry.register(
  (state) => getCurrentConference(state),
  (conference, { dispatch, getState }, previousConference) => {
    if (conference !== previousConference) {
      dispatch(resetWhiteboard());
    }
    if (conference && !previousConference) {
      conference.on(JitsiConferenceEvents.METADATA_UPDATED, (metadata) => {
        // console.log('whiteboard metadata', metadata);
        if (metadata[WHITEBOARD_ID]) {
          dispatch(
            setupWhiteboard({
              collabDetails: metadata[WHITEBOARD_ID].collabDetails
            })
          );
          if (isWhiteboardPresent(getState()))
            dispatch(setWhiteboardOpen(true));
        }
      });
    }
  }
);
